<script lang="ts">
	import type { ISbRichtext, ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import Blok from '../blok.svelte';
	import SbRichtext from '../components/sbRichtext.svelte';
	import { isEmpty } from '$lib/utils/storyblok/richtext';
	import PageGrid16 from '../components/pageGrid16.svelte';
	import type { SbColor } from '../types';

	interface Props {
		content: ISbStoryData<{
			id: string;
			nav_name: string;
			headline?: ISbRichtext;
			subheadline?: ISbRichtext;
			body: Array<ISbStoryData>;
			bg_color?: SbColor;
			bg_style?: 'fullbleed' | 'containered';
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<section
	class={[
		'content-section',
		content.bg_color && `bg-${content.bg_color}`,
		(!content.bg_style || content.bg_style === 'containered') && `lg:m-5 lg:rounded-xl`
	]}
	use:editable={content}
	id={content.id}
	data-nav-name={content.nav_name}
>
	{#if content.headline && !isEmpty(content.headline)}
		<PageGrid16 margin>
			<div class="col-span-full mb-6 text-center lg:col-start-4 lg:col-end-[14] lg:mb-8">
				<div
					class="text-pretty text-[44px]/[108%] tracking-[-.44px] text-brown-1 lg:text-[64px]/[104%] lg:tracking-[-.64px]"
				>
					<SbRichtext text={content.headline} />
				</div>

				{#if content.subheadline && !isEmpty(content.subheadline)}
					<div
						class="mt-3 text-pretty text-[16px]/[150%] tracking-[-.16px] text-brown-4 lg:mt-5 lg:text-[20px]/[140%] lg:tracking-[-.2px]"
					>
						<SbRichtext text={content.subheadline} />
					</div>
				{/if}
			</div>
		</PageGrid16>
	{/if}

	{#each content.body as block}
		<Blok content={block} />
	{/each}
</section>

<style lang="scss">
	section.content-section {
		scroll-margin-top: var(--full-header-height);
	}
</style>
